/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import moment from 'moment';
import Link from 'next/link';
import _ from 'lodash';

import { withTranslation } from 'language/i18n';
import { getAllBlogs } from 'models/blog';
import Breadcrumb from 'components/Breadcrumb';
import Layout from 'components/partials/Layout';
import { Button } from 'components/common';
import { getObjectByLanguage } from 'language/helpers';
import BlogListItem from './components/BlogListItem';

const Blog = ({ t, blogs, popularBlog }) => {
  const [lastListedBlogIndex, setLastListedBlogIndex] = useState(5);

  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: 'Blog',
      url: '/blog',
    },
  ];

  return (
    <main className="has-header">
      <div className="container" style={{ minHeight: 500 }}>
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <div className="col-15 mt-md-0">
            {popularBlog && (
              <div className="row mb-20">

                <div className="col-15">
                  <Link href={`/blog/${popularBlog.id}`}>
                    <a className="blog-card blog-card--large">
                      <div className="blog-card-image">
                        {popularBlog.image
                              && (
                                <Image
                                  src={popularBlog.image}
                                  layout="fill"
                                  objectFit="cover"
                                />
                              )}
                      </div>
                      <div className="blog-card-text-area">
                        <span className="blog-card-date">
                          <strong>
                            {moment(popularBlog.date).format('DD MMMM YYYY, HH:mm')}
                          </strong>
                          {' '}
                          tarihinde yayınlandı.
                        </span>
                        <span className="blog-card-title">{getObjectByLanguage(popularBlog.title)}</span>
                        <span className="blog-card-description">{popularBlog.description}</span>
                      </div>
                    </a>
                  </Link>
                </div>
              </div>
            )}
            <div className="row mb-20">
              {
                _.map(blogs.slice(0, lastListedBlogIndex), (blog, index) => {
                  if (blog?.isPopular === false) {
                    return (
                      <div className={`col-15 col-md-7 col-lg-5 mb-20 ${index % 2 === 1 && 'offset-md-1 offset-lg-0'}`}>
                        <BlogListItem key={blog.id} blog={blog} />
                      </div>
                    );
                  }
                  return null;
                })
              }
            </div>
          </div>
        </div>
        { blogs.length > lastListedBlogIndex && (
          <Button
            className="im-button im-button--size-52 im-button--primary im-button--fluid im-button--center mb-30"
            label="Daha Fazla Yazı Göster"
            withoutFormItem
            onClick={() => setLastListedBlogIndex(lastListedBlogIndex + 5)}
          />
        )}
      </div>
    </main>
  );
};

Blog.propTypes = {
  t: PropTypes.func,
  blogs: PropTypes.array,
  popularBlog: PropTypes.object,
};

export const getServerSideProps = async () => {
  try {
    const blogs = await getAllBlogs();
    const sortedBlogs = blogs.sort((a, b) => {
      return new Date(b.date) - new Date(a.date);
    });
    const popular = _.find(blogs, ['isPopular', true]) || null;
    return {
      props: {
        blackHeader: true,
        headTitle: 'Blog',
        blogs: sortedBlogs,
        popularBlog: popular,
      },
    };
  } catch (error) {
    console.error('Error fetching blogs:', error);
    return {
      props: {
        blackHeader: true,
        headTitle: 'Blog',
        blogs: [],
      },
    };
  }
};

Blog.Layout = Layout;

export default withTranslation('common')(Blog);
